<template>
  <div class="w-100 text-center no-ws py-2">
    <template v-for="(menu,index) in steps">
      <template v-if="is_mobile_view">
        <div class="d-inline-block align-middle mb-2">
          <div class="mr-2 d-inline-block align-middle">
            <div class="be-step-cart" :class="{'active-mobile':menu.id <= step}">
              <span class="body-3-3-2" v-if="menu.id > step || (menu.id == step && index+1 < steps.length)" :class="menu.id == step? 'text-green' : 'text-white'">{{ menu.id }}</span>
              <div v-else>
                <svg width="14" height="12" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.79995 10.9L1.59995 6.7L0.199951 8.1L5.79995 13.7L17.8 1.7L16.4 0.300003L5.79995 10.9Z" class="svg-primary"/>
                </svg>
              </div>
            </div>
          </div>
          <p class="mb-0 d-inline-block align-middle text-white" :class="menu.id != step ?'body-3':'body-3-3-2'">{{ menu.name }}</p>
        </div>
        <div class="d-inline-block align-middle mx-3 mb-2" v-if="(index+1) < steps.length">
          <svg width="14" height="13" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.74994 20.414L7.33594 19L14.3359 12L7.33594 5L8.74994 3.586L17.1639 12L8.74994 20.414Z" fill="#fff"/>
          </svg>
        </div>
      </template>
      <template v-else>
        <div class="d-inline-block align-middle">
          <div class="be-step-cart mr-2 d-inline-block align-middle" :class="{'active':menu.id <= step}">
            <span class="body-2-4" v-if="menu.id > step || (menu.id == step && index+1 < steps.length)" :class="{'text-white': menu.id == step }">{{ menu.id }}</span>
            <div v-else style="line-height: 35px;">
              <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.79995 10.9L1.59995 6.7L0.199951 8.1L5.79995 13.7L17.8 1.7L16.4 0.300003L5.79995 10.9Z" fill="#fff"/>
              </svg>
            </div>
          </div>
          <p class="mb-0 d-inline-block align-middle" :class="menu.id != step ?'body-2-1':'body-2-4 text-green'">{{ menu.name }}</p>
        </div>
        <div class="d-inline-block align-middle mx-4 px-3" v-if="(index+1) < steps.length">
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.74994 20.414L7.33594 19L14.3359 12L7.33594 5L8.74994 3.586L17.1639 12L8.74994 20.414Z" fill="#222"/>
          </svg>
        </div>
      </template>
    </template>
  </div>
</template>
<script>
  export default{
    props:{
      step:{
        type: Number,
        default: 1,
      },
      need_payment:{
        type: Boolean,
        default: false
      }
    },
    data(){
      return{
        window_width: window.innerWidth
      }
    },
    computed:{
      steps(){
        let menu = [
          {id: 1, name: 'Select Room'},
          {id: 2, name: 'Fill in data'},
          {id: 3, name: 'Process'},
          {id: 4, name: 'Complete'}
        ]
        if(this.need_payment){
          menu.splice(2, 0,{id:3, name:'Payment'})
          menu[3].id = 4
          menu[4].id = 5
        }
        return menu
      },
      is_mobile_view(){
        return this.window_width <= 768
      }
    },
    mounted(){
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResizeWindow);
      })
    },
    beforeDestroy() { 
      window.removeEventListener('resize', this.onResizeWindow); 
    },
		methods:{
			onResizeWindow(){
        this.window_width = window.innerWidth
      }
		}
  }
</script>
<style>
  .be-step-cart{
    width: 35px;
    height: 35px;
    background-color: #ececec;
    border-radius: 50%;
    border: 1px solid #9f9f9f;
    text-align: center;
    display: grid;
    place-items: center;
  }
  .be-step-cart.active{
    background-color: var(--merchant-primary-color);
    border: 1px solid var(--merchant-primary-color);
  }
  .be-step-cart.active-mobile{
    background-color: #fff;
    border: 1px solid #fff;
  }
  .svg-primary{
    fill: var(--merchant-primary-color)
  }
  @media screen and (max-width: 768px){
    .be-step-cart{
      background-color: var(--merchant-primary-color);
      border: 1px solid #fff;
    }
  }
  @media screen and (max-width: 576px){
    .be-step-cart{
      width: 25px;
      height: 25px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/desktop/headerStepOrder.vue